/* src/app/auth/signin/signin.component.scss */
.logo {
  width: 430px;
  margin: -50px 0 50px 0;
}
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-top: 40px;
  margin-bottom: 65px;
  color: #a2a6b0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: "Campton-Light";
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 25px;
}
.note {
  color: #a2a6b0;
  margin-top: -10px;
  margin-bottom: 20px;
}
.container input {
  position: absolute;
  cursor: pointer;
  height: 25px;
  width: 25px;
  left: 0px;
}
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #262933;
  border-radius: 3px;
  border: 1px solid #a2a6b0;
}
.container:hover input ~ .checkmark {
  background-color: #555969;
}
.container input:checked ~ .checkmark {
  background-color: #262933;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.container input:checked ~ .checkmark:after {
  display: block;
}
.container .checkmark:after {
  left: 7px;
  top: -1px;
  width: 10px;
  height: 20px;
  border: solid #6ccc09;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.privacy-link {
  color: #a2a6b0;
  text-decoration: none;
  border-bottom: 1px dashed;
}
h2.signup {
  white-space: nowrap;
}
.forgot-password,
show-password {
  text-align: left;
  float: left;
  margin-left: 16px;
  padding-top: 12px;
}
.input-group {
  position: relative;
  display: flex;
  align-items: center;
}
.input-group .input-group-addon {
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  z-index: 4;
  display: flex;
  align-items: center;
  border-bottom: none;
}
.form-control {
  padding-right: 40px;
}
.carousel-control-prev {
  position: relative;
  width: auto;
  opacity: 1;
  color: #555A69;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  top: auto;
  bottom: auto;
  left: auto;
}
.carousel-control-prev span {
  margin-left: 8px;
  font-family: "Campton-Light";
  font-size: 14px;
}
.carousel-control-prev:hover {
  opacity: 0.8;
  background: none;
}
.carousel-control-prev svg {
}
/*# sourceMappingURL=signin.component.css.map */
